import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faBoxOpen,
  faFillDrip,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import StatisticsCard from "../uielements/StatisticsCard";
import Api from "../../helpers/apiHandler";
import countsActions from "../../redux/counts/actions";
import { newPermissionValue } from "../../helpers/constants";
import { hasSidebarModuleAccess } from "../../helpers/utility";
import { prefetchRoutes } from "../../helpers/prefetchRoutes";
import materialsIcon from "../../image/materials-icon.svg";

const { updateCount } = countsActions;
const api = new Api();

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media only screen and (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media only screen and (max-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const InventoryCounts = ({
  onUpdateCount,
  counts,
  companyId,
  sideBarItems,
  ...props
}) => {
  const [count, setCount] = useState({});
  const [isIngredients, setIsIngredients] = useState(false);
  const [isMaterials, setIsMaterials] = useState(false);
  const [isInventory, setIsInventory] = useState(false);
  const [isFinishedGoods, setIsFinishedGoods] = useState(false);
  const [isLotDocumentation, setIsLotDocumentation] = useState(false);

  useEffect(() => {
    if (sideBarItems && sideBarItems.length > 0) {
      sideBarItems.forEach((item) => {
        const moduleName = String(item.moduleName || "")
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");
        const description = String(
          item.moduleDescription || item.description || ""
        )
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");

        if (item.moduleName === "ingredients") {
          if (item.permissionId != newPermissionValue.noAccess) {
            setIsIngredients(true);
          } else {
            setIsIngredients(false);
          }
        }
        if (item.moduleName === "materials") {
          if (item.permissionId != newPermissionValue.noAccess) {
            setIsMaterials(true);
          } else {
            setIsMaterials(false);
          }
        }
        if (item.moduleName === "inventory") {
          if (item.permissionId != newPermissionValue.noAccess) {
            setIsInventory(true);
          } else {
            setIsInventory(false);
          }
        }
        if (
          moduleName === "finishedgoods" ||
          moduleName === "finishedgood" ||
          description === "finishedgoods" ||
          description === "finishedgood"
        ) {
          setIsFinishedGoods(item.permissionId != newPermissionValue.noAccess);
        }
      });
      setIsLotDocumentation(
        hasSidebarModuleAccess(sideBarItems, {
          moduleName: "Lot Documentation",
          description: "Lot Documentation",
        })
      );
    }
  }, [sideBarItems]);

  useEffect(() => {
    const paths = [];
    if (isInventory) paths.push("inventory");
    if (isIngredients) paths.push("ingredients");
    if (isMaterials) paths.push("materials");
    if (isFinishedGoods) paths.push("finished-goods");
    if (isLotDocumentation) paths.push("inventory/lot-documentation");
    prefetchRoutes(paths);
  }, [
    isInventory,
    isIngredients,
    isMaterials,
    isFinishedGoods,
    isLotDocumentation,
  ]);

  useEffect(() => {
    if (companyId) {
      getCount();
    }
  }, [companyId]);

  useEffect(() => {
    if (counts) {
      setCount(counts);
    }
  }, [counts]);

  const getCount = () => {
    if (!companyId) return;
    
    const payload = {
      companyId: companyId,
      menuType: "PRODUCTION",
    };
    
    api
      .post("common/count", {
        isMultipart: false,
        data: payload,
      })
      .then((response) => {
        if (response.status === 1) {
          onUpdateCount({
            inventory: {
              ingredients: response.data.ingredient || 0,
              materials: response.data.material || 0,
              finishedGoods: response.data.finishedGood || 0,
            },
          });
        }
      })
      .catch((error) => {
        console.log("Error fetching counts:", error);
      });
  };

  const redirectRoute = (routname) => {
    if (props.location.pathname !== routname) {
      props.history.push(routname);
    }
  };

  return (
    <GridContainer className="width-100" style={{ marginBottom: "20px" }}>
      {isInventory && (
        <StatisticsCard
          title={"Inventory"}
          icon={
            <FontAwesomeIcon
              icon={faWarehouse}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#20CCE2"}
          showOnlyTitle
          to="/inventory"
          onClick={() => redirectRoute("/inventory")}
        />
      )}
      {isIngredients && (
        <StatisticsCard
          title={"Ingredients"}
          count={count.ingredients || 0}
          icon={
            <FontAwesomeIcon
              icon={faFillDrip}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#8BBC27"}
          to="/ingredients"
          onClick={() => redirectRoute("/ingredients")}
        />
      )}
      {isMaterials && (
        <StatisticsCard
          title={"Materials"}
          count={count.materials || 0}
          icon={
            <img
              src={materialsIcon}
              alt="Materials"
              style={{
                height: "16px",
                width: "16px",
              }}
            />
          }
          color={"#4E4599"}
          to="/materials"
          onClick={() => redirectRoute("/materials")}
        />
      )}
      {isFinishedGoods && (
        <StatisticsCard
          title={"Finished Goods"}
          count={count.finishedGoods || 0}
          icon={
            <FontAwesomeIcon
              icon={faBoxOpen}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#6C8CD5"}
          to="/finished-goods"
          onClick={() => redirectRoute("/finished-goods")}
        />
      )}
      {isLotDocumentation && (
        <StatisticsCard
          title={"Lot Documentation"}
          icon={
            <FontAwesomeIcon
              icon={faBook}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#9D6AB0"}
          showOnlyTitle
          to="/inventory/lot-documentation"
          onClick={() => redirectRoute("/inventory/lot-documentation")}
        />
      )}
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.Auth.company.id,
  counts: state.Counts.inventory,
  sideBarItems: state.Auth.sideBarItems,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateCount: (data) => dispatch(updateCount(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InventoryCounts)
);

